import { render, staticRenderFns } from "./UploadImagemEmailAniversarioLocatarioDialog.vue?vue&type=template&id=562261a8&"
import script from "./UploadImagemEmailAniversarioLocatarioDialog.vue?vue&type=script&lang=js&"
export * from "./UploadImagemEmailAniversarioLocatarioDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports